module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_5_3_3_cell120.a6304ef2.png";